/* global gsap */
let index;
let nextIndex;
let lastDirection;
let first = true;

const cells = document.querySelectorAll('[data-ref="cell"]');

const rotate = (event, direction) => {
  const btn = event.target.closest('button');
  btn.setAttribute('disabled', true);

  // put active on top,
  // remove current next
  // put new next as next,
  // active does clip path animate,

  cells.forEach((cell) => {
    cell.classList.remove('is-top');
    cell.classList.remove('is-next');
  });

  if (first) {
    if (direction == 'next') {
      index = -1;
      nextIndex = (index + 1);
    } else {
      index = 1;
      nextIndex = (cells.length - 1);
    }
  }

  // Set indices
  if (direction == 'next') {
    if (lastDirection == 'prev') {
      index = nextIndex;
      nextIndex = (index + 1) % cells.length;
    } else {
      index = (index + 1) % cells.length;
      nextIndex = (index + 1) % cells.length;
    }
  } else {
    if (lastDirection == 'next') {
      index = nextIndex;
      nextIndex = (index == 0) ? (cells.length - 1) : index - 1;
    } else {
      index = (index == 0) ? (cells.length - 1) : index - 1;
      nextIndex = (index == 0) ? (cells.length - 1) : index - 1;
    }
  }

  cells[index].classList.add('is-top');
  cells[nextIndex].classList.add('is-next');

  gsap.to(cells[index], {
    clipPath: 'polygon(0 0, 0% 0%, 0% 100%, 0% 100%)',
    ease: 'power2.easeOut',
    duration: 0.75,
    overwrite: true,
    onComplete: function() {
      // move to back
      cells[index].classList.remove('is-top');

      // reset clip path so it can be animated again
      gsap.set(cells[index], {
        clipPath: 'polygon(0 0, 125% 0, 100% 100%, 0% 100%)',
      });

      btn.removeAttribute('disabled');
    },
  });

  first = false;
  lastDirection = direction;
};

const init = () => {
  const cover = document.querySelector('[data-ref="carousel-cover"]');

  if (!cover) {
    return;
  }

  const clip = gsap.to(cover, {
    clipPath: 'polygon(0 0, 0% 0%, 0% 100%, 0% 100%)',
    paused: true,
    ease: 'power2.easeOut',
    duration: 0.75,
  });

  const startBtn = document.querySelector('[data-ref="start"]');
  const prevBtn = document.querySelector('[data-ref="prev-btn"]');
  const nextBtn = document.querySelector('[data-ref="next-btn"]');

  if (startBtn && prevBtn && nextBtn) {
    startBtn.addEventListener('click', () => {
      clip.play(0);
    });

    prevBtn.addEventListener('click', (event) => {
      rotate(event, 'prev');
    });

    nextBtn.addEventListener('click', (event) => {
      rotate(event, 'next');
    });
  }
};

init();
